import sortByLevenshtein from './sortByLevenshtein';
import { Profile } from '../components/Jobs/JobDetail/JobProperties';

const getMostRelevantProfile = (
  profiles: Profile[],
  companyName: string,
) => sortByLevenshtein<Profile>(
  [...profiles],
  companyName.toLowerCase(),
  (profile) => profile.company.fullName.toLowerCase(),
);

export default getMostRelevantProfile;
